/// <reference types="vite/client" />
import {
  HeadContent,
  Scripts,
  createRootRoute,
} from '@tanstack/react-router';
import * as React from 'react';
import { DefaultCatchBoundary } from '../components/DefaultCatchBoundary';
import { NotFound } from '../components/NotFound';
import { AmplitudeInit } from '../components/analytics/AmplitudeInit';
import { CookieConsent } from '../components/analytics/CookieConsent';
import { GoogleAnalyticsInit } from '../components/analytics/GoogleAnalyticsInit';
import appCss from '../styles/app.css?url';
import fontsCss from '../styles/fonts.css?url';
import { seo } from '../utils/seo';

export const Route = createRootRoute({
  head: () => ({
    meta: [
      {
        charSet: "utf-8",
      },
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1",
      },
      ...seo({
        title: "CoPlane",
        description:
          "The intelligent operations layer for the enterprise.",
        image: "/OG.png",
      }),
    ],
    links: [
      { rel: "stylesheet", href: appCss },
      { rel: "stylesheet", href: fontsCss },
      {
        rel: "apple-touch-icon",
        sizes: "180x180",
        href: "/apple-touch-icon.png",
      },
      {
        rel: "icon",
        type: "image/png",
        sizes: "32x32",
        href: "/favicon-32x32.png",
      },
      {
        rel: "icon",
        type: "image/png",
        sizes: "16x16",
        href: "/favicon-16x16.png",
      },
      { rel: "icon", href: "/favicon.ico" },
    ],
    scripts: [
      // Google Analytics - script loaded, but initialization is conditional via GoogleAnalyticsInit component
      {
        src: "https://www.googletagmanager.com/gtag/js?id=G-7QX695K229",
        async: true,
      },
    ],
  }),
  errorComponent: DefaultCatchBoundary,
  notFoundComponent: () => <NotFound />,
  shellComponent: RootDocument,
});

function RootDocument({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en">
      <head>
        <HeadContent />
      </head>
      <body>
        <GoogleAnalyticsInit />
        <AmplitudeInit />
        <CookieConsent />
        {children}
        {/* {env.NODE_ENV !== "production" && (  
        <TanStackDevtools
          config={{
            position: "bottom-right",
          }}
          plugins={[
            {
              name: "Tanstack Router",
              render: <TanStackRouterDevtoolsPanel />,
            },
          ]}
        />
        )} */}
        <Scripts />
      </body>
    </html>
  );
}
